import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Textarea, AlertNotice } from 'shared/components';
import { isEmpty } from 'lodash';
import { AdmissionTicketSample } from 'features/tc-renewal/index';
import './AdmissionTab.scss';

const MESSAGE_MAX_LENGTH = 360;
class AdmissionTab extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { tcEvent, testCenterName, message, eventLocation } = this.props;

    return (
      <div className="admission-tab-section">
        <h5 className="pb-3">{tcEvent.testingEvent.name}</h5>
        <h5>{this.props.t('requestUpdate.admissionSection.currentMessage')}</h5>
        <div className="pb-3">
          {tcEvent.message
            ? tcEvent.message
            : this.props.t('requestUpdate.admissionSection.noCurrentMessage')}
        </div>
        <AlertNotice message={this.props.t('requestUpdate.admissionSection.infoMessage')} />
        <Textarea
          value={message}
          name="ticketMessage"
          label="requestUpdate.admissionSection.newMessageLabel"
          labelInfo={this.props.t('requestUpdate.admissionSection.newMessageLabelInfo')}
          maxLength={MESSAGE_MAX_LENGTH}
          onChange={(e) => this.props.onAdmissionUpdate(e.target.value)}
          clearValue={() => this.props.onAdmissionUpdate('')}
          isValueChanged={tcEvent.message ? message !== tcEvent.message : !isEmpty(message)}
        />
        <AdmissionTicketSample
          message={message}
          testCenterName={testCenterName}
          location={eventLocation}
        />
      </div>
    );
  }
}

export default withTranslation()(AdmissionTab);
AdmissionTab.propTypes = {
  tcEvent: PropTypes.shape({
    message: PropTypes.string,
  }).isRequired,
  testCenterName: PropTypes.string.isRequired,
  eventLocation: PropTypes.shape({}),
  message: PropTypes.string,
  onAdmissionUpdate: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

AdmissionTab.defaultProps = {};
